<template>
	<div>
		<action-sidebar
			:title="title"
			:value="true"
			@close-modal="closeModal"
		>
			<v-layout wrap pa-5>
				<v-flex xs12 pb-3>
					<v-text-field
						background-color="white"
						box
						class="body-1"
						hide-details
						label="Nombre"
						v-model="$v.model.name.$model"
						:error="$v.model.name.$error"
					>
					</v-text-field>
				</v-flex>
				<v-flex xs12 pb-3>
					<v-textarea
						background-color="white"
						box
						class="body-1"
						height="80"
						hide-details
						label="Descripción"
						no-resize
						v-model="model.description"
					>
					</v-textarea>
				</v-flex>
				<v-flex xs12 pb-3>
					<v-select
						background-color="white"
						class="body-1 mt-2"
						box
						hide-details
						item-text="domain"
						item-value="code"
						label="Dominio"
						:items="domains"
						v-model="$v.model.domain.$model"
						:error="$v.model.domain.$error"
					></v-select>
				</v-flex>
				<v-flex xs12 pb-3>
					<v-select
						background-color="white"
						class="body-1 mt-2"
						box
						hide-details
						item-text="name"
						item-value="code"
						label="Métodos"
						:items="methods"
						v-model="$v.model.method.$model"
						:error="$v.model.method.$error"
					></v-select>
				</v-flex>
				<v-flex xs12 pb-3>
					<v-text-field
						background-color="white"
						box
						class="body-1"
						hide-details
						label="Path"
						v-model="$v.model.path.$model"
						:error="$v.model.path.$error"
					>
					</v-text-field>
				</v-flex>
				<v-flex xs12 pb-3>
					<v-select
						background-color="white"
						class="body-1 mt-2"
						box
						hide-details
						item-text="name"
						item-value="code"
						label="Plataformas"
						:items="platforms"
						v-model="model.platform"
					></v-select>
				</v-flex>
			</v-layout>
			<section class="modal-filter-footer">
				<modal-sidebar-button
					:is-loading="$v.$invalid || loading"
					@accept-button-clicked="saveService"
					@cancel-button-clicked="closeModal"
				>
				</modal-sidebar-button>
			</section>
		</action-sidebar>
	</div>
</template>

<script>
	import actionSidebar from '@/components/shared/action-sidebar';
	import { required } from 'vuelidate/lib/validators';

	function closeModal() {
		this.goTo('page-web-services');
	}

	async function saveService() {
		const method = this.id ? 'put' : 'post';
		const url = this.id ? `master-services/${this.id}` : 'master-services';
		const message = this.id ? 'modificó' : 'creó';
		try {
			await this.$http[method](url, this.model);
			this.showNotification(`Se ${message} el servicio correctamente`);
			this.closeModal();
		} catch (error) {
			this.showError();
		}
	}

	function title() {
		const action = 'Web Service';
		return this.id ? `Editar ${action}` : `Nueva ${action}`;
	}

	async function loadData() {
		const requests = [this.$http.get(`projects/${this.codeProject}/domains`)];
		if (this.id) {
			requests.push(this.$http.get(`master-services/${this.id}`));
		}
		try {
			const responses = await Promise.all(requests);
			[{ data: this.domains }] = responses;
			if (this.id) {
				[, { data: this.model }] = responses;
				this.model = this.model.data;
				this.model.codeProject = this.codeProject;
			}
		} catch (error) {
			this.showError();
		}
	}

	function created() {
		this.loadData();
	}

	function validations() {
		const validation = {
			model: {
				name: {
					required,
				},
				domain: {
					required,
				},
				method: {
					required,
				},
				path: {
					required,
				},
			},
		};
		return validation;
	}

	function data() {
		return {
			domains: [],
			methods: [
				{ code: 'GET', name: 'GET' },
				{ code: 'POST', name: 'POST' },
				{ code: 'PATCH', name: 'PATCH' },
				{ code: 'PUT', name: 'PUT' },
				{ code: 'DELETE', name: 'DELETE' },
			],
			platforms: [
				{ code: 1, name: 'Web' },
				{ code: 2, name: 'Movil' },
				{ code: 3, name: 'Movil/Web' },
			],
			loading: false,
			model: {
				name: null,
				description: null,
				domain: null,
				method: null,
				path: null,
				platform: null,
				codeProject: this.codeProject,
			},
		};
	}

	export default {
		name: 'page-new-web-services',
		data,
		components: {
			actionSidebar,
		},
		created,
		computed: {
			title,
		},
		methods: {
			closeModal,
			loadData,
			saveService,
		},
		props: {
			id: {
				type: [Number, String],
			},
			codeProject: {
				type: String,
			},
		},
		validations,
	};
</script>



// WEBPACK FOOTER //
// src/pages/web-services/page-new-web-services.vue